import { localStorageNameAutostart } from "./constants";

export function isDefined(obj: unknown): boolean {
    return typeof obj !== "undefined" && obj !== null;
}

export function isValidTargetRect(targetRect: DOMRect): boolean {
    return targetRect !== null && targetRect.width > 0 && targetRect.height > 0;
}

export function getAutoStartEnabled(hash: string): boolean {
    if (typeof window === "undefined") {
        return false;
    }
    const storage = window.localStorage.getItem(localStorageNameAutostart);
    let hashes: string[] = [];
    if (storage) {
        try {
            hashes = JSON.parse(storage) as string[];
        } catch {
            window.localStorage.removeItem(localStorageNameAutostart);
        }
    }
    return !hashes.includes(hash);
}

export function setAutoStartEnabled(val: boolean, hash: string) {
    if (typeof window === "undefined") {
        return;
    }
    const storage = window.localStorage.getItem(localStorageNameAutostart);
    let hashes: string[] = [];
    if (storage) {
        try {
            hashes = JSON.parse(storage) as string[];
        } catch {
            window.localStorage.removeItem(localStorageNameAutostart);
        }
    }
    if (val) {
        hashes = hashes.filter((item) => item !== hash);
    } else {
        if (!hashes.includes(hash)) {
            hashes.push(hash);
        }
    }
    window.localStorage.setItem(localStorageNameAutostart, JSON.stringify(hashes));
}
